export const vehicleCategories = [
  { id: "all", icon: "ri-apps-2-line" },
  { id: "bikes", icon: "ri-motorbike-fill" },
  { id: "scooters", icon: "ri-e-bike-2-fill" },
  { id: "cars", icon: "ri-car-fill" },
];

export const vehicles = [
  {
    id: 1,
    name: "Honda Activa 125",
    category: "scooters",
    badgeKey: "foodDelivery",
    image:
      "https://storage.readdy-site.link/project_files/27323d3e-a7b2-4c27-a226-1c860a229b7d/ed4cddcf-f28f-454e-bbfa-3ec97b5e5cab_compressed_514111.webp",
    fuel: 55,
    seats: 2,
    priceValue: "18,000",
  },
  {
    id: 2,
    name: "Hero Splendor Plus",
    category: "bikes",
    badgeKey: "mileage",
    image:
      "https://storage.readdy-site.link/project_files/27323d3e-a7b2-4c27-a226-1c860a229b7d/a22f54f1-7d24-4d31-be68-c3b4711fccba_compressed_514108.webp",
    fuel: 70,
    seats: 2,
    priceValue: "30,000",
  },
  {
    id: 3,
    name: "TVS Jupiter",
    category: "scooters",
    badgeKey: "comfort",
    image:
      "https://storage.readdy-site.link/project_files/27323d3e-a7b2-4c27-a226-1c860a229b7d/87b58b8c-d145-4f4c-9ff0-7201c074c650_compressed_514116.webp",
    fuel: 60,
    seats: 2,
    priceValue: "17,000",
  },
  {
    id: 4,
    name: "Bajaj Pulsar 150",
    category: "bikes",
    badgeKey: "courier",
    image: "https://public.readdy.ai/ai/img_res/edited_df6d70bf37ece9471de36dee9a4d34d7_352066d0.jpg",
    fuel: 50,
    seats: 2,
    priceValue: "40,000",
  },
  {
    id: 5,
    name: "Hyundai i10 Sedan",
    category: "cars",
    badgeKey: "taxi",
    image: "https://public.readdy.ai/ai/img_res/edited_bf998dc4a26f7d4fc6eaf36989c818fc_476c3311.jpg",
    fuel: 20,
    seats: 4,
    priceValue: "55,000",
  },
  {
    id: 6,
    name: "Kia Rio Hatchback",
    category: "cars",
    badgeKey: "family",
    image: "https://public.readdy.ai/ai/img_res/edited_cc66f69d736ff94e792ab320368bd316_aee84063.jpg",
    fuel: 18,
    seats: 5,
    priceValue: "60,000",
  },
  {
    id: 7,
    name: "Hero Splendor 125",
    category: "bikes",
    badgeKey: "premium",
    image:
      "https://storage.readdy-site.link/project_files/27323d3e-a7b2-4c27-a226-1c860a229b7d/a22f54f1-7d24-4d31-be68-c3b4711fccba_compressed_514108.webp",
    fuel: 65,
    seats: 2,
    priceValue: "30,000",
  },
];